/*
	import { eraseBoardMeeting } from '@/services/BoardMeetings/BoardPackage/Delete';

  const { successful } = await eraseBoardMeeting ({
    boardPackageID
  });
*/

/*

*/

import kms from '@/services/kms'
import { notifyError } from '@/services/notify'

export async function eraseBoardMeeting({ boardPackageID }) {
  let exception = ''

  try {
    const result = await kms.delete(`/BoardMeetings/BoardPackage/${boardPackageID}`)

    return {
      successful: true,
      message: 'The board meeting was deleted successfully.',
      exception: null,
      phoneMeeting: result
    }
  } catch (_exception) {
    exception = _exception
  }

  let message = 'A problem occurred and the board meeting could not be deleted.'
  notifyError(message)

  return {
    successful: false,
    message,
    exception,
    phoneMeeting: null
  }
}
